// @ts-nocheck
import { get } from "@insite/client-framework/Services/ApiService";
import { GetProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import { FastenerCollectionModel } from "@store/Framework/Types/ApiModels";

const fastenerUrl = "/api/v1/custom/fastener";

export async function getFasteners(parameter: GetFastenersCollectionApiParameter) {
    const fastenerCollection = await get<FastenerCollectionModel>(fastenerUrl, parameter);
    return fastenerCollection;
}

export interface GetFastenersCollectionApiParameter extends GetProductCollectionApiV2Parameter {
    productId: string;
    length?: string;
    boxCount?: string;
    headDiameter?: string;
    thread?: string;
    driveType?: string;
    point?: string;
    head?: string;
    finish?: string;
    sortBy?: string;
    sortOrder?: string;
}
